import React, { useState } from "react";
import Day from "/components/estate-calendar/components/Day";
import { TIME_SELECTION, APPOINTMENT_FORM } from "/components/estate-calendar/components/Calendar";

export default props => {
    const monthNames = {
        0: 'januari',
        1: 'februari',
        2: 'maart',
        3: 'april',
        4: 'mei',
        5: 'juni',
        6: 'juli',
        7: 'augustus',
        8: 'september',
        9: 'oktober',
        10: 'november',
        11: 'december',
    };

    const handleConfirm = appointmentId => {
        props.setAppointmentId(appointmentId);
        props.setSelectedPane(APPOINTMENT_FORM);
    }

    const isSameDay = (firstDay, secondDay) => (
        firstDay.getFullYear() === secondDay.getFullYear() &&
        firstDay.getMonth() === secondDay.getMonth() &&
        firstDay.getDate() === secondDay.getDate()
    );

    return (
        <>
            <div className="calendar__title-container">
                <h2 className="calendar__title">Boek een afspraak</h2>
            </div>
            <div className="calendar__date-toggle">
                <h2 className="calendar__date">{ monthNames[props.selectedDate.getMonth()] } { props.selectedDate.getFullYear() }</h2>
                <h2 className="calendar__toggle">
                    <span
                        onClick={ props.canGoLower ? props.subtractWeek : null }
                        className={ props.canGoLower ? "calendar__toggle-button" : "calendar__toggle-button calendar__toggle-button--disabled" }
                    >
                        {"<"}
                    </span>
                    {" "}
                    <span
                        onClick={ props.addWeek }
                        className="calendar__toggle-button"
                    >
                        {">"}
                    </span>
                </h2>
            </div>
            <div className="calendar__days">
                { props.week.map( day => (
                    <Day
                        day={ day }
                        isToday={ props.currentDate.getTime() === day.getTime() }
                        key={ day.toString() }
                        clickHandler={ handleConfirm }
                        appointments={ props.appointments.filter( appointment => isSameDay(appointment.appointmentDate, day) ) }
                    />
                ))}
            </div>
        </>
    );
};
